<template>
  <div class="press-link">
    <div class="press-link__title">
      <text-input
        placeholder="Title"
        v-model="form.title"
        @input="emit"
      />
    </div>
    <div class="press-link__publication">
      <div>
        <text-input
          placeholder="Publication"
          v-model="form.publication"
          @input="emit"
        />
      </div>
      <div>
        <text-input
          placeholder="URL"
          v-model="form.url"
          @input="emit"
        />
      </div>
    </div>
    <a class="press-link__remove" @click="$emit('remove')">
      <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
          fill="#231F1C" stroke="#231F1C" stroke-width="2"
          stroke-linecap="round" stroke-linejoin="round"
        />
        <path d="M15 9l-6 6M9 9l6 6" stroke="#FFF8F2" stroke-width="2"
         stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </a>
  </div>
</template>

<script>
import TextInput from '@/components/TextInput.vue';

export default {
  name: 'pressLink',
  components: {
    TextInput,
  },
  props: {
    title: String,
    publication: String,
    url: String,
  },
  data() {
    return {
      form: { ...this.$props },
    };
  },
  created() {
    this.emit();
  },
  methods: {
    emit() {
      this.$emit('input', this.form);
    },
  },
};
</script>

<style lang="scss" scoped>
.press-link {
  position: relative;
  padding: 20px;
  background: rgba(0,0,0,0.02);
  border-radius: var(--radius);
  margin-bottom: 20px;
  width: 100%;
  > div {
    margin: 20px;
  }
  &__publication {
    display: flex;
    > * {
      margin-right: 10px;
      &:last-child {
        margin-right: 0;
        flex: 1;
      }
    }
  }
  &__remove {
    position: absolute;
    top: -5px;
    right: -5px;
  }
}
</style>
